var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navigation"},[_c('transition-group',{attrs:{"appear":"","tag":"div","name":"navigation-transition"},on:{"before-enter":_vm.beforeEnterTransition}},_vm._l((_vm.$router.options.routes.filter(function (x) { return x.meta.mainPageScroll; })),function(route){return _c('router-link',{key:route.name,staticClass:"navigation_item",attrs:{"to":{
      name: route.name,
      params: {
        lang: _vm.$route.params.lang
      }
    }}},[_c('span',[_vm._v(_vm._s(_vm.$t(("router." + (route.name)))))])])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }